export default "__VITE_ASSET__df442690__"